import { observer } from "mobx-react-lite";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useTran } from "@/hooks";
import { FormField, SelectField } from "@/components/common";
import { LOCATION_OPTIONS } from "@/lib/constants";
import { translateCountry } from "@/lib/constants/translations.map";

const CompanySetupStepOne = observer(
  ({
    companyNameError,
    companyNameDescription,
    companyNameDescriptionClassName,
  }) => {
    const { t, i18n } = useTran();
    const {
      values,
      touched,
      errors,
      handleBlur,
      setFieldValue,
      setFieldTouched,
    } = useFormikContext();

    const getFieldError = (key) => (touched?.[key] ? errors?.[key] : undefined);

    const handleCompanyNameChange = (event) => {
      const nextValue = event?.target?.value || "";
      setFieldValue("companyName", nextValue, true);
      setFieldTouched("companyName", true, false);
    };

    const handleCountryChange = (event) => {
      const nextValue = event?.target?.value || "";
      setFieldValue("country", nextValue, true);
      setFieldTouched("country", true, false);
    };

    const countryOptions = useMemo(() => {
      console.log("language:", i18n.language);
      console.log("test:", translateCountry("Singapore", i18n.language));
      return LOCATION_OPTIONS.map((option) => ({
        key: option.key,
        value: translateCountry(option.value, i18n.language),
      }));
    }, [i18n.language]);

    return (
      <div className="space-y-6">
        <div className="space-y-2">
          <FormField
            label={t("company_name_question")}
            required
            name="companyName"
            value={values.companyName}
            onChange={handleCompanyNameChange}
            onBlur={handleBlur}
            placeholder="Acme Inc."
            error={companyNameError || getFieldError("companyName")}
          />
          {companyNameDescription ? (
            <p
              className={
                companyNameDescriptionClassName ||
                "text-xs text-muted-foreground"
              }
            >
              {companyNameDescription}
            </p>
          ) : null}
        </div>

        <SelectField
          id="country"
          label={t("company_location_question")}
          required
          placeholder={t("select_a_country")}
          value={values.country}
          options={countryOptions}
          onChange={handleCountryChange}
          error={getFieldError("country")}
        />
      </div>
    );
  },
);

export default CompanySetupStepOne;
